/**
 * Utility functions shared across components
 */

/**
 * @param {Record<string, unknown> | null | undefined} obj
 * @param {string} path
 * @returns {unknown}
 */
export function getNestedProperty(obj, path) {
    if (!obj || !path) return undefined;
    /** @type {unknown} */
    let current = obj;
    for (const part of path.split('.')) {
        if (current == null || typeof current !== 'object') return undefined;
        current = /** @type {Record<string, unknown>} */ (current)[part];
    }
    return current;
}

